async function detectElement(elemId, parentElem) {
    return new Promise((resolve) => {
        const observer = new MutationObserver(function (mutationsList, observer) {
            $(mutationsList).each(function (_, mutation) {
                if (mutation.type === "childList") {
                    $(mutation.addedNodes).each(function () {
                        if (this.nodeType === 1 && this.id === elemId) {
                            observer.disconnect();
                            resolve(this); // or just resolve() if you don’t need the element
                        }
                    });
                }
            });
        });

        observer.observe(parentElem, { childList: true });
    });
}

module.exports = {
    detectElement
};
